// src/index.tsx
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { ProcessingProvider } from './context/ProcessingContext';
import './styles/styles.css';

// Get root element
const container = document.getElementById('root');

// Ensure container exists
if (!container) {
  throw new Error(
    'Root element not found. Make sure there is a <div id="root"></div> in your HTML file.'
  );
}

// Create root and render app
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ProcessingProvider>
      <App />
    </ProcessingProvider>
  </React.StrictMode>
);

// Hot Module Replacement (HMR) - Development only
if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept('./App', () => {
    const NextApp = require('./App').default;
    root.render(
      <React.StrictMode>
        <ProcessingProvider>
          <NextApp />
        </ProcessingProvider>
      </React.StrictMode>
    );
  });
}

// Handle runtime errors
window.addEventListener('error', (event: ErrorEvent) => {
  console.error('Runtime error:', event.error);
  // You could add error reporting service integration here
});

// Handle unhandled promise rejections
window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
  console.error('Unhandled promise rejection:', event.reason);
  // You could add error reporting service integration here
});